import { academicGroupRoutesObj, academicGroupBreadcrumbs } from "./path";

import { createRoute } from "@/routes/utils";
import { IRole } from "@/interfaces";
import type { IRouteMetadataObj } from "@/routes/types";

const permission = [IRole.STAFF, IRole.SUPER_ADMIN, IRole.DEPARTMENT_STAFF];

export const academicGroupRouteMetadata: IRouteMetadataObj<
  typeof academicGroupRoutesObj
> = {
  list: {
    title: "academicGroupsManagement",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/academicGroup/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewAcademicGroup",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/academicGroup/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editAcademicGroupOf",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/academicGroup/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewAcademicGroupOf",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/academicGroup/view/page"),
    mode: "view",
    permission,
  },
};

export const academicGroupRoutes = createRoute<typeof academicGroupRoutesObj>(
  academicGroupRoutesObj,
  academicGroupRouteMetadata,
  academicGroupBreadcrumbs,
);
